
import { Component, Prop, Vue } from 'vue-property-decorator';
import eventBus from '@/utils/eventBus';
import { checkPermissionCompany } from '@/utils/permission';
import { UserModule } from '@/store/modules/user';
import { Type } from '@/types/permissionType';

@Component({
  name: 'GroupSearch',
  components: {

  }
})
export default class extends Vue {
  @Prop({
    type: String,
    default: 0,
    required: true
  })
  enterType!:any;
  // 1 客户推单 2地址 3故障 4标签 5组合推单 6报修部门推单

  private formSearch:any = {
    customer: '',
    address: '',
    fault: '',
    tags: '',
    deptCustomer: '', // 报修部门
    device: '', // 设备
    dept: '',
    engineer: ''
  };
  private isAddress=false;
  private isFaultPhenomenon=false;
  private isTags=false;
  private isCustomer=false;
  private isDevice = false;
  created() {
    this.isAddress = checkPermissionCompany(UserModule.getCompanyId, Type.pca) || checkPermissionCompany(UserModule.getCompanyId, Type.myselfPCALs);
    this.isFaultPhenomenon = checkPermissionCompany(UserModule.getCompanyId, Type.FAULT_PHENOMENON);
    this.isTags = checkPermissionCompany(UserModule.getCompanyId, Type.tag);
    this.isCustomer = checkPermissionCompany(UserModule.getCompanyId, Type.CUSTOMER_COMPANY);
    this.isDevice = checkPermissionCompany(UserModule.getCompanyId, Type.Device);
  }
  // 清空
  private handleSearchClear() {
    this.formSearch = {
      customer: '',
      address: '',
      fault: '',
      tags: '',
      deptCustomer: '',
      device: '',
      dept: '',
      engineer: ''
    };
    eventBus.$emit('groupSearch', this.formSearch);
  }

  // 搜索
  private handleSearch() {
    eventBus.$emit('groupSearch', this.formSearch);
  }
}
